import dayjs from "dayjs";
import "dayjs/locale/fr";
import localizedFormat from "dayjs/plugin/localizedFormat"

dayjs.extend(localizedFormat);
dayjs.locale('fr');

